<template>
    <div class="header layout layout-align-space-between">
        <div :class="isZxg ? 'logo-zxg' : 'logo-wzq'"></div>
        <div class="rule-link" @click="showRuleDialog(type = (isZxg ? 'zxg' : 'wzq'))">活动规则</div>
    </div>
</template>
<script lang="jsx">
  import qs from 'qs';
  import BackDrop from '../../../../component-dev/backdrop';
  import Dialog from '../../../../component-dev/dialog';
  import Button from '../../../../component-dev/button';
  import config from '../../config.json';
  import { IS_ZXG, IS_MQQ } from '../../../../service/platform/environment';
  import { makeStatReportParam } from '../../../../service/stat/Directive';
  import { stat } from '../../../../service/stat';
  function platformAdapter(str, isZxg) {
    if (isZxg) {
      return str
        .replace('微证券', '自选股')
    }
    return str;
  }

  export default {
    data() {
      return {
        curpage: ''
      }
    },
    props: {
        components: {
          Dialog,
          Button,
        }
    },

    computed: {
      isZxg() {
        const query = qs.parse(location.search.substring(1));
        return IS_MQQ ||
          IS_ZXG ||
          this.$route.query.from === 'zxg' ||
          query.from === 'zxg' || query._from === 'zxg' || this.$route.query._from === 'zxg';
      }
    },
    
    methods: {
      showRuleDialog(type) {
        const rule = config.RULE[type];
        const unmount = BackDrop.mount({
            source: 'page',
            target: 'root',
            applyFilterFor: '#root',
            content: (
              <transition>
                <div class="layout-column layout-align-center-center">
                  <Dialog class="activity-rule">
                    <template slot="header">
                      <h3 class="header-content">{rule.title}</h3>
                    </template>
                    <template slot="main">
                      <ul class="rule-ul">
                        {
                          rule.content.map((line) => platformAdapter(line, this.isZxg)).map((line) => <li class="rule-item">{line}</li>)
                  }
                    </ul>
                  </template>
        
                  <template slot="footer">
                    <Button v-stat="RULE_DIALOG_OK" class="glyph-font page-button" nativeOnClick={() => this.dialogClose()} >知道了</Button>
                  </template>
                </Dialog>
                </div>
            </transition>
      )
      }, this.$createElement);
        this.unmount = unmount;
        const currentPath = this.$route.path;
        if (currentPath == '/') {
          this.curpage = 'index';
        } else {
          this.curpage = 'getreward'
        }
        if (IS_ZXG) {
          stat.sendClickStat(
            makeStatReportParam(`19newyear.${this.curpage}.rule.click.zxg`, currentPath),
            currentPath,
          );
        } else {
          stat.sendClickStat(
            makeStatReportParam(`19newyear.${this.curpage}.rule.click`, currentPath),
            currentPath,
          );
        }
      },
      
      dialogClose() {
        let self = this;
        const currentPath = this.$route.path;
        if (currentPath == '/') {
          this.curpage = 'index';
        } else {
          this.curpage = 'getreward'
        }
        if (IS_ZXG) {
          stat.sendClickStat(
            makeStatReportParam(`19newyear.${this.curpage}.ruleclose.click.zxg`, currentPath),
            currentPath,
          );
        } else {
          stat.sendClickStat(
            makeStatReportParam(`19newyear.${this.curpage}.ruleclose.click`, currentPath),
            currentPath,
          );
        }
        this.unmount();
      }
    }
  }
</script>
<style lang="scss">
    @import "~@tencent/stylepack/sass/mixin";
    .header {
        padding: 20px 38px 0 30px;
    }
    .logo-wzq {
        width: 170px;
        height: 32px;
        background: url("../../images/logo_wzq.png") no-repeat center center;
        background-size: contain;
    }
    .logo-zxg {
        width: 170px;
        height: 32px;
        background: url("../../images/logo_zxg.png") no-repeat center center;
        background-size: contain;
    }
    .rule-link {
        font-size: 26px;
        color: #C1A97A;
        text-decoration: underline;
    }

    .header-trigger {
        background-image: linear-gradient(to bottom, #FF8C02, #FF7322);
        background-color: #FFDA7E;
        color: #FFDA7E;
        padding: 10px 12px;
        font-size: 27px;
        cursor: pointer;
        @include border-bottom-radius(12px);
    }

    ol {
        padding: 0;
        margin: 0;
        margin-left: 32px;

        li + li {
            margin-top: 12px;
        }
    }

    .reward-list {
        margin-top: -20px;
        max-height: 500px;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }

    .reward {
        color: #DF8D0B;
        padding: 0 32px;

        & + & {
            margin-top: 24px;
        }

        .reward-date {
            margin-top: -4px;
            .reward-date-day {
                font-size: 44px;
            }

            .reward-date-month {
                font-size: 26px;
                margin-top: -15px;
            }
        }

        .reward-detail {
            margin: 4px 16px;

            .reward-detail-main {
                font-size: 32px;
                font-weight: bold;
            }

            .reward-detail-sub {
                font-size: 26px;
            }
        }
        .reward-amount {
            color: #FE480F;
            font-size: 38px;
        }
    }
</style>

   
